import { useEffect, useState } from 'react';
import {
    Half1Icon,
    UpdateIcon
} from '@radix-ui/react-icons';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import {
    Form
} from '../ui/form';
import { toast } from '../ui/use-toast';
import { Link } from 'react-router';
import { useForm } from 'react-hook-form';
import api from '../../lib/api';
import SelectBunnyPopover from '../selectBunnyPopver';

function TestInbreedingDialog() {
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isTimeout, setIsTimeout] = useState(false);

    const form = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [formData, setFormData] = useState({
        father: '',
        mother: '',
    });

    const [results, setResults] = useState();

    const getInbreeding = (e) => {
        e.preventDefault();
        if (isLoading || isTimeout) return; // Prevent multiple clicks

        setIsLoading(true);
        setIsTimeout(true);

        api.get(`https://skhrf-api.cmdigital.se/v1/bunnies/inbreeding?fatherId=${formData.father}&motherId=${formData.mother}`)
            .then(response => {
                setResults(response.data);
            })
            .catch(error => {
                toast({
                    variant: 'destructive',
                    title: 'Något gick fel.',
                    description: error?.response?.data?.error,
                });
            })
            .finally(() => {
                setIsLoading(false);
                setTimeout(() => {
                    setIsTimeout(false);
                }, 5000);
            });
    };

    useEffect(() => {
        if (!isDialogOpen) {
            form.reset({
                father: '',
                mother: '',
            });
        }
    }, [isDialogOpen, form]);

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DialogTrigger asChild>
                <Button className='xl:col-start-3 xl:col-span-2'>
                    <Half1Icon className='mr-3' />
                    Provparning
                </Button>
            </DialogTrigger>
            <DialogContent>
                <DialogHeader className='text-left'>
                    <DialogTitle>Provparning</DialogTitle>
                    <DialogDescription>Ange far och mor för att beräkna inavelsprocent.</DialogDescription>
                </DialogHeader>
                <Form {...form}>
                    <form onSubmit={getInbreeding} className="flex flex-col gap-6">
                        <SelectBunnyPopover
                            form={form}
                            name="father"
                            label="Far"
                            gender="male"
                            onSelect={(bunnyId) => setFormData(prevState => ({ ...prevState, father: bunnyId }))}
                            allowDead={true}
                        />
                        <SelectBunnyPopover
                            form={form}
                            name="mother"
                            label="Mor"
                            gender="female"
                            onSelect={(bunnyId) => setFormData(prevState => ({ ...prevState, mother: bunnyId }))}
                            allowDead={true}
                        />
                        {results &&
                            <div>
                                <p>Inavelsprocent: <span className='font-medium'>{(results?.inbreedingCoefficient * 100).toFixed(2)}</span> %</p>
                                {results?.cachedFromLitter && <p className='text-sm mt-3'>Observera att inavelsprocenten hämtades from ett lagrat resultat av far- och morkombination från kullen <Link className='text-blue-600 font-medium hover:underline' to={`/litters/` + results?.cachedFromLitter.id}>{results?.cachedFromLitter.name}</Link>.</p>}
                            </div>
                        }
                        <div className='grid grid-cols-2 gap-3'>
                            <DialogClose asChild>
                                <Button type='button' variant='secondary'>Avbryt</Button>
                            </DialogClose>
                            <Button type="submit" onClick={() => setResults()} disabled={isLoading || !formData.father || !formData.mother || isTimeout}>
                                {isLoading ? <UpdateIcon className='loader-spinner' /> : <>Testa</>}
                            </Button>
                        </div>
                    </form>
                </Form>


            </DialogContent>
        </Dialog>
    );
};

export default TestInbreedingDialog;
